export default "__VITE_ASSET__BJwByeUS__"